import {createContext, use} from 'react'
import type {Author} from '../types'

const CurrentUserContext = createContext<Author | undefined>(undefined)

export function CurrentUserProvider({user, children}: React.PropsWithChildren<{user?: Author}>) {
  return <CurrentUserContext value={user}> {children} </CurrentUserContext>
}

export function useCurrentUser() {
  return use(CurrentUserContext)
}
